/**
 * Alert engine — Phase 2 stub.
 * Called by the pipeline for every event. Returns empty alerts in Phase 1.
 */

import type { NormalizedEvent } from '@/sources/base-source';
import type {
  AlertEngine,
  AlertRule,
  Alert,
  AlertFilter,
  Geofence,
} from './types';

class AlertEngineStub implements AlertEngine {
  async addRule(_rule: Omit<AlertRule, 'id' | 'createdAt' | 'triggerCount'>): Promise<AlertRule> {
    throw new Error('Alert engine not implemented in Phase 1');
  }

  async removeRule(_ruleId: string): Promise<void> {
    // No-op in Phase 1
  }

  async updateRule(_ruleId: string, _changes: Partial<AlertRule>): Promise<AlertRule> {
    throw new Error('Alert engine not implemented in Phase 1');
  }

  async getRules(): Promise<AlertRule[]> {
    return [];
  }

  async getAlerts(_filter?: AlertFilter): Promise<Alert[]> {
    return [];
  }

  async acknowledge(_alertId: string): Promise<void> {
    // No-op in Phase 1
  }

  async evaluate(_event: NormalizedEvent): Promise<Alert[]> {
    return [];
  }

  async addGeofence(_geofence: Omit<Geofence, 'id'>): Promise<Geofence> {
    throw new Error('Alert engine not implemented in Phase 1');
  }

  async getGeofences(): Promise<Geofence[]> {
    return [];
  }
}

export const alertEngine = new AlertEngineStub();
